import * as z from "zod";

export const deleteTiktokAdsIntegration = {
  name: "deleteTiktokAdsIntegration" as const,
  input: z.null(),
  output: z.object({ success: z.boolean() }),
};
